import { operator } from "../use-filter-operators";
import { searchNewProducts } from "components/search-tool/lib/searchData";
import { searchAdvancedFiltersFields } from "components/task-list/lib/constants";
import { useMutation } from "react-query";

export const useShipmentStatuses = () => {
    return useMutation(({ shipmentKeys }) => {
        return searchNewProducts({
            filters: [
                {
                    innerFilters: shipmentKeys.map((shipmentKey) => {
                        return {
                            column: searchAdvancedFiltersFields.shipmentKey.name,
                            value: shipmentKey,
                            operator: operator.eq,
                        };
                    }),
                },
            ],
            pagingInfo: {
                pageNumber: 1,
                pageSize: 100,
            },
        });
    });
};
